module.exports = __webpack_public_path__ + "static/img/qudi (3).14e0565.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qudi/qudi (3).jpg
// module id = kfZo
// module chunks = 0